import { useEffect, useState } from 'react';
import { getPAGAA000, getPAGAJ010 } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { updateMenuVisibility } from '../../../utils';
const PAGAJ010 = () => {
    const [nps, setNps] = useState([]);
    const [wps, setWps] = useState([]);
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));

        getPAGAJ010()
            .then(({ data }) => {
                setNps(data.nps);
                setWps(data.wps);
            })
            .catch((error) => console.log(error));

        window.scrollTo(0, 0);
    }, []);

    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div className="container container-800">
                <div className="top-table-image">
                    <img src="./images/PAGAJ010/top-image-sample.png" alt="Computer" />
                    <p className="top-table-image-note">
                        개별 수료증 및 이수증 보관/참석자 명단 및 서명을 포함한 교육일지 3년간 보존해야 합니다.
                    </p>
                </div>
                <div className="tbl tbl_st">
                    <h2 className="title-table purple">미이수 시 과태료가 있는 교육({wps.length}개)</h2>
                    <table className="table_training_courses">
                        <thead>
                            <tr>
                                <th style={{ width: 180 }}>교육명</th>
                                <th style={{ width: 360 }}>교육대상 및 횟수</th>
                                <th style={{ width: 130 }}>교육 자료 및 양식</th>
                                <th style={{ width: 130 }}>관련 링크</th>
                            </tr>
                        </thead>
                        <tbody>
                            {wps && wps.length > 0 ? (
                                wps?.map((item) => (
                                    <tr key={item?.seq}>
                                        <td>{item?.title}</td>
                                        <td>
                                            {item?.content.split('\n').map((line, idx) => (
                                                <span key={idx}>
                                                    {line}
                                                    <br />
                                                </span>
                                            ))}
                                        </td>
                                        <td
                                            colSpan={2}
                                            className={`td-icon ${!item?.agency || item?.agency === '' ? 'agencyTrue' : ''
                                                }`}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div className="wrap-icon">
                                                    {item?.fileName !== '' ? (
                                                        <a
                                                            className="item-icon"
                                                            href={`https://api.dentaljob.co.kr/api/v1/files/education/${item?.fileName}/download`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <i className="icon icon-zip" />
                                                        </a>
                                                    ) : (
                                                        <div style={{ flex: 0.5 }}></div>
                                                    )}
                                                    <div style={{ flex: 0.5 }}>
                                                        {item?.urlTitle !== '' && (
                                                            <p
                                                                style={{
                                                                    fontSize: '13px',
                                                                    wordBreak: 'break-word',
                                                                    color: '#666',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    flex: '.5',
                                                                    textAlign: 'center',
                                                                    justifyContent: 'center',
                                                                    height: item?.url === '' ? '100%' : 'auto',
                                                                    padding: '0 5px',
                                                                }}
                                                            >
                                                                {item?.urlTitle}
                                                            </p>
                                                        )}
                                                        {item?.url !== '' && (
                                                            <a
                                                                href={item?.url}
                                                                className="item-icon"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                <i className="icon icon-link" />
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                                {item?.agency || (item?.agency !== '' && item?.agency !== null) ? (
                                                    <p
                                                        style={{
                                                            fontSize: '13px',
                                                            wordBreak: 'break-word',
                                                            color: '#666',
                                                        }}
                                                    >
                                                        *출처: {item?.agency}
                                                    </p>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4}>데이터없습니다</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="tbl tbl_nd">
                    <h2 className="title-table blue">미이수 시 과태료가 없는 교육({nps.length}개)</h2>
                    <table className="table_training_courses blue">
                        <thead>
                            <tr>
                                <th style={{ width: 180 }}>교육명</th>
                                <th style={{ width: 360 }}>교육대상 및 횟수</th>
                                <th style={{ width: 130 }}>교육 자료 및 양식</th>
                                <th style={{ width: 130 }}>관련 링크</th>
                            </tr>
                        </thead>
                        <tbody>
                            {nps && nps.length > 0 ? (
                                nps.map((item) => (
                                    <tr key={item?.seq}>
                                        <td>{item?.title}</td>
                                        <td>
                                            {item?.content.split('\n').map((line, idx) => (
                                                <span key={idx}>
                                                    {line}
                                                    <br />
                                                </span>
                                            ))}
                                        </td>
                                        <td
                                            colSpan={2}
                                            className={`td-icon ${!item?.agency || item?.agency === '' ? 'agencyTrue' : ''
                                                }`}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <div className="wrap-icon">
                                                    {item?.fileName !== '' ? (
                                                        <a
                                                            className="item-icon"
                                                            href={`https://api.dentaljob.co.kr/api/v1/files/education/${item?.fileName}/download`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <i className="icon icon-zip" />
                                                        </a>
                                                    ) : (
                                                        <div style={{ flex: 0.5 }}></div>
                                                    )}
                                                    <div style={{ flex: 0.5 }}>
                                                        {item?.urlTitle !== '' && (
                                                            <p
                                                                style={{
                                                                    fontSize: '13px',
                                                                    wordBreak: 'break-word',
                                                                    color: '#666',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    flex: '.5',
                                                                    textAlign: 'center',
                                                                    justifyContent: 'center',
                                                                    height: item?.url === '' ? '100%' : 'auto',
                                                                    padding: '0 5px',
                                                                }}
                                                            >
                                                                {item?.urlTitle}
                                                            </p>
                                                        )}
                                                        {item?.url !== '' && (
                                                            <a
                                                                href={item?.url}
                                                                className="item-icon"
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                <i className="icon icon-link" />
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                                {item?.agency || item?.agency !== '' ? (
                                                    <p
                                                        style={{
                                                            fontSize: '13px',
                                                            wordBreak: 'break-word',
                                                            color: '#666',
                                                        }}
                                                    >
                                                        *출처: {item?.agency}
                                                    </p>
                                                ) : (
                                                    ''
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={4}>데이터없습니다</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
export default PAGAJ010;
